import gql from 'graphql-tag';

import { STOCK_TRANSFER_FRAGMENT } from '../fragments/stockTransfer';

export const STOCK_TRANSFERS_UPDATED_SUBSCRIPTION = gql`
    subscription STOCK_TRANSFERS_UPDATED($stockTransferId: ID) {
        stockTransferUpdated(stockTransferId: $stockTransferId) {
            ...StockTransferFragment
            isForReassortment
            numberOfRefs
            quantityOfProducts
        }
    }
    ${STOCK_TRANSFER_FRAGMENT}
`;
